import React, { useState } from 'react';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { AudienceLadder } from '../components/AudienceLadder';
import { IntroducingPulseMarkets } from '../components/IntroducingPulseMarkets';
import { CreatorLabProgram } from '../components/CreatorLabProgram';
import { ProofStats } from '../components/ProofStats';
import { FAQ } from '../components/FAQ';
import { ApplicationModal } from '../components/ApplicationModal';
import { Footer } from '../components/Footer';
export function LandingPage() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  return <div className="min-h-screen bg-navy-950 text-slate-100 font-sans selection:bg-mint-500/30" data-id="element-551">
      <Navigation onApplyClick={openModal} data-id="element-552" />
      <main data-id="element-553">
        <Hero onApplyClick={openModal} data-id="element-554" />
        <AudienceLadder data-id="element-555" />
        <IntroducingPulseMarkets data-id="element-556" />
        <CreatorLabProgram onApplyClick={openModal} data-id="element-557" />
        <ProofStats data-id="element-558" />
        <FAQ data-id="element-559" />
      </main>
      <Footer data-id="element-560" />

      <ApplicationModal isOpen={isModalOpen} onClose={closeModal} data-id="element-561" />
    </div>;
}